/* eslint-disable */

import { useEffect, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { createCommand, COMMAND_PRIORITY_EDITOR, $insertNodes, $isRootOrShadowRoot, $createParagraphNode } from 'lexical';
import { $wrapNodeInElement } from "@lexical/utils";

import CasBaseDialog from '../../CasDialog/CasBaseDialog';
import CasButton from '../../CasButton/CasButton';
import { useRetrieveDetailsById } from 'src/compass/shared/hooks/reactQuery/useRetrieveDetailsById';
import { BranchSelect } from 'src/compass/application/admin/components/EmployeeTab/_internal/BranchSelect';
import { $createNumberBoxNode } from '../CasLexicalNumber/CasLexicalInputNumberNode';
import CasLoaderWithBackdrop from '../../CasLoader/CasLoaderWithBackdrop';

export const SHOW_NUMBER_INPUT_DIALOG_COMMAND = createCommand();

export function CasNumberBoxDialogHandlerPlugin() {
  const [editor] = useLexicalComposerContext();
  const [showDialog, setShowDialog] = useState(false);
  const [inputNumber, setInputNumber] = useState('');
  const [numberToFetch, setNumberToFetch] = useState<number | null>(null);

  const { isFetching } = useRetrieveDetailsById({
    entity: 'Branch',
    id: numberToFetch ?? 0,
    enabled: !!numberToFetch,
    onSuccess: (response: any) => {
      if (response && numberToFetch != null) {
        editor.update(() => {
          const payload = JSON.stringify({ inputNumber, response });
          const node = $createNumberBoxNode(payload);
          $insertNodes([node]);

        if ($isRootOrShadowRoot(node.getParentOrThrow())) {
          $wrapNodeInElement(node, $createParagraphNode).selectEnd();
        }
        });
        setShowDialog(false);
      }
    },
  });

  useEffect(() => {
    return editor.registerCommand(
      SHOW_NUMBER_INPUT_DIALOG_COMMAND,
      () => {
        setInputNumber('');
        setNumberToFetch(null);
        setShowDialog(true);
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  const handleSave = () => {
    const parsed = parseInt(inputNumber, 10);
    if (!isNaN(parsed)) {
      setNumberToFetch(parsed);
    }
  };

  return showDialog ? (
    <CasBaseDialog open title="Add Branch" onClose={() => setShowDialog(false)}>
      {isFetching && <CasLoaderWithBackdrop />}
      <BranchSelect
        label="Branch"
        value={inputNumber}
        onChange={(_, val) => setInputNumber(val)}
        sx={{ minWidth: 150 }}
      />
      <CasButton onClick={handleSave}>Save</CasButton>
    </CasBaseDialog>
  ) : null;
}
